const BordMoneyExchangeIcon = () => {
  return (
    <svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 8C1.5 5.51214 3.51214 3.5 6 3.5L5.35714 4.78571M16.5 11C16.5 13.4879 14.4879 15.5 12 15.5L12.6429 14.2143M12.7499 5.375H12.7566M5.24986 13.625H5.25659M16.1739 2.12926C15.5186 2.00913 14.3102 1.82066 12.9375 2.3867C11.5737 2.94905 10.2013 3.06932 9.41337 3.05412C9.19144 3.04984 9 3.24629 9 3.496V8.34263C9 8.55925 9.14542 8.74075 9.33789 8.74685C10.1115 8.77137 11.529 8.66211 12.9375 8.08135C14.2475 7.54119 15.4078 7.68812 16.0805 7.80708C16.3035 7.84651 16.5 7.65712 16.5 7.4032V2.55896C16.5 2.34636 16.3604 2.16345 16.1739 2.12926ZM8.67385 10.3793C8.01859 10.2591 6.81024 10.0707 5.4375 10.6367C4.07369 11.1991 2.70134 11.3193 1.91337 11.3041C1.69144 11.2998 1.5 11.4963 1.5 11.746V16.5926C1.5 16.8093 1.64542 16.9908 1.83789 16.9969C2.61148 17.0214 4.02904 16.9121 5.4375 16.3313C6.74748 15.7912 7.90775 15.9381 8.58054 16.0571C8.80351 16.0965 9 15.9071 9 15.6532V10.809C9 10.5964 8.86037 10.4135 8.67385 10.3793Z"
        stroke="#C6C7CB"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default BordMoneyExchangeIcon;
